import {useState} from "react";
import {
    CompanySettingModel,
    ComponentActionTypeEnum, DailyTransactionTypeEnum,
    LookupItemModel, StoreTransferSearchTransactionRequestModel,
    StoreTransferSearchTransactionResponseModel,
    StoreTransferTransactionDetailResponseModel,
    ToastModel,
    TransactionItemResponseModel, TransactionResponseModel, UserConfigurationModel, UserSettingModel,
    UserTransactionsSettingResponseModel,
    ValidationErrorModel
} from "../../../../../models";
import {
    companySettingInitialValues,
    transactionItemInitialValues,
    userSettingInitialValues, userTransactionsSettingInitialValues
} from "../../../common/businessLogic/transactionBl";
import {storeTransferTransactionDetailInitialValue} from "../../../common/businessLogic/storeTransferTransactionBl";

export const useStoreTransferState = ( transactionType: DailyTransactionTypeEnum) => {
    //#region state
    const [loading, setLoading] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const [forceRerender, setForceRerender] = useState(false);
    const[isResetReference,setIsResetReference]=useState<boolean>(false);
    const [showPrintoutPdfModel, setShowPrintoutPdfModel] = useState(false);
    const [showDeleteModel, setShowDeleteModel] = useState(false);

    const [validationErrors, setValidationErrors] = useState<ValidationErrorModel[]>([]);
    const[lookupList,setLookupList]=useState<LookupItemModel[]>([]);
    const [userSetting, setUserSetting] = useState<UserSettingModel>(userSettingInitialValues);
    const [companySetting,setCompanySetting]=useState<CompanySettingModel>(companySettingInitialValues)
    const [settings,setSettings]=useState<UserTransactionsSettingResponseModel[]>([])
    const [userTransactionSetting, setUserTransactionSetting] = useState<UserTransactionsSettingResponseModel>(userTransactionsSettingInitialValues);
    const[transactionList,setTransactionList]=useState<StoreTransferSearchTransactionResponseModel[]>([]);

    const [toastModel, setToastModel] = useState<ToastModel>({
        show: false,
        variant: "success",
    });

    const [data, setData] = useState<StoreTransferTransactionDetailResponseModel >(
        storeTransferTransactionDetailInitialValue
    );
    const [transactionItemObject, setTransactionItemObject] =
        useState<TransactionItemResponseModel>(transactionItemInitialValues);

    const[fromStoreId,setFromStoreId]=useState<number|null>(null);
    const[toStoreId,setToStoreId]=useState<number|null>(null);
    const [componentActionType, setComponentActionType] =
        useState<ComponentActionTypeEnum>(ComponentActionTypeEnum.None);


    const [totalRows, setTotalRows] = useState(0);
    const [searchRequest, setSearchRequest] =
        useState<StoreTransferSearchTransactionRequestModel>({pageNumber: 1,pageSize: 50});
    const [printTransactionId, setPrintTransactionId] = useState(0);

    const [transactionResponseObject, setTransactionResponseObject] = useState<TransactionResponseModel | null>(null);
    //#endregion
    return {
        loading, setLoading,
        validationErrors, setValidationErrors,
        toastModel, setToastModel,
        lookupList,setLookupList,
        settings,setSettings,
        fromStoreId,setFromStoreId,
        toStoreId,setToStoreId,
        data, setData,
        transactionItemObject, setTransactionItemObject,
        forceRerender,setForceRerender,
        isRefresh,setIsRefresh,
        isResetReference,setIsResetReference,
        componentActionType, setComponentActionType,
        transactionList,setTransactionList,
        totalRows, setTotalRows,
        searchRequest, setSearchRequest,
        printTransactionId, setPrintTransactionId,
        showPrintoutPdfModel, setShowPrintoutPdfModel,
        showDeleteModel, setShowDeleteModel,
        transactionResponseObject, setTransactionResponseObject,
        userConfiguration:{
            userSetting,
            companySetting,
            userTransactionSetting
        } as UserConfigurationModel,
    };
}